import { Event } from '@tribeplatform/gql-client/types'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { ActionButtons } from './ActionButtons.js'
import { EventAbout } from './EventAbout.js'
import { EventInformationSection } from './EventInformation.js'
import { EventLocationMap } from './LocationMap.js'
import { RecurrenceInformation } from './RecurrenceInformation.js'
import { RegistrationConfirmationAlert } from './RegistrationConfirmationAlert.js'
import { isRecurringEvent } from './utils.js'

interface Props {
  event: Event
}

export const RightSideColumn = ({ event }: Props) => {
  const isRecurring = isRecurringEvent(event)

  return (
    <div className="flex flex-col gap-y-2 relative p-4 pt-0 sm:p-6">
      <div className="flex flex-col gap-y-4">
        <Text variant="headingSm" className="line-clamp-3">
          {event.title}
        </Text>
        {isRecurring && (
          <RecurrenceInformation
            frequency={event.recurrenceConfig?.frequency}
            repeatsOn={event.recurrenceConfig?.repeatsOn ?? []}
          />
        )}
        <RegistrationConfirmationAlert event={event} />
        <EventInformationSection event={event} />
        <EventLocationMap locations={event.physicalLocations} />
        <EventAbout event={event} />
      </div>
      <div className="sm:hidden sticky bottom-0 sm:pe-0 bg-surface py-4 border-t border-line -mx-1 rounded-b-base">
        <ActionButtons event={event} />
      </div>
    </div>
  )
}
